import services from "../assets/js/services";
import router from '../router/router'
import utils from "../assets/js/utils";
export default {
    state: {
        activityDetail: null, // 活动详情
        chapterData: [], // 章节列表 
        taskData: [], // 任务列表
    },
    getters: {

    },
    actions: {
        // 活动详情
        methodActivityDetail (context, payload) {
            return services.getCenterActivityDetail(payload).then(res => {
                if (res.code == '0000') {
                    context.commit('setActivityDetail', {
                        'data': res.data ? res.data : {}
                    })
                }
            })
        },
        // 章节列表
        methodChapterData (context, payload) {
            return services.getCenterChapter(payload).then(res => {
                if (res.code == '0000') {
                    context.commit('setChapterData', {
                        'data': res.data ? res.data : []
                    })
                }
            })
        },
        // 任务列表
        methodTaskData (context, payload) {
            return services.getCenterTask(payload).then(res => {
                if (res.code == '0000') {
                    context.commit('setTaskData', {
                        'data': res.data ? res.data : [],
                        'is_progress': payload.is_progress
                    })
                }
            })
        },
    },
    mutations: {
        // 设置活动详情
        setActivityDetail (state, payload) {
            state.activityDetail = payload.data;
        },
        // 设置章节列表
        setChapterData (state, payload) {
            state.chapterData = payload.data
        },
        // 设置任务列表
        setTaskData (state, payload) {
            state.taskData = payload.data
            // 初始化左侧任务菜单的跳转路径
            if (payload.is_progress == 1) {
                let school_code = utils.getUrlSchoolCode(window.location.pathname)
                state.taskData.forEach(item => {
                    let routers = router.options.routes.find(item => item.path.includes("/student/experiment")).children
                    let childLength = item.children.length
                    item.children.forEach((sub_item) => {
                        let matchedRoute = routers.find(item => item.code == sub_item.code);
                        // 如果找不到匹配的路由，跳过该任务
                        if (!matchedRoute) {
                            console.warn(`未找到匹配的路由 for code: ${sub_item.code}`)
                            return
                        }
                        let path = `/${school_code}/student/experiment/${matchedRoute.path}`;
                        if (childLength == 1) {
                            item.path = path
                        } else {
                            item.path = item.children[0].path
                        }
                        sub_item.path = path
                    })
                })
                // console.log(state.taskData)
            }
        },
    }

}